/**
 * `name` → **Settings** (spec M1-B5 §6.2, M2 tier-1 §5.1, card P-123).
 *
 * The item-name column configures **nothing**: `nameSettingsSchema` is `z.looseObject({})`, it can
 * never be hidden (`[B5§9 L10]`), never deleted and its width is the sticky *region*, not a cell
 * (P-021). monday has no *Customize Name column* row either.
 *
 * It still gets a dialog rather than a disabled menu row, because "Settings does nothing" and
 * "Settings is not implemented" look identical from the outside and P-123 is precisely the second
 * one being mistaken for the first. The dialog says which it is, and *Apply* commits the settings
 * unchanged — which the service's no-op gate (`canonicalJson` compare) drops without a revision
 * bump or an activity row.
 */
import type { NameSettings } from '@elizmonday/shared';
import { SettingsForm, useSettingsDraft } from '../settings-kit';
import type { ColumnSettingsProps } from '../types';

export function NameSettingsDialog({ settings, onCommit, onCancel }: ColumnSettingsProps<NameSettings>) {
  const [draft] = useSettingsDraft<NameSettings>(settings);
  return (
    <SettingsForm
      title="Name column settings"
      testId="name-settings"
      onSave={() => onCommit(draft)}
      onCancel={onCancel}
    >
      <p className="ez-type-settings__empty" data-testid="name-no-settings">
        The item name column has nothing to configure: it is always first, always visible, and its
        width is the board&rsquo;s sticky region rather than a cell.
      </p>
    </SettingsForm>
  );
}
